<div class="container">
  <img src="/assets/images/icon.png" height="40" />
  <div>Power-Water</div>
</div>
